module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_oc-2ccd772852823cbff50dbc233c935c36.gif";